export default __webpack_public_path__ + "images/referenzen/imagefilm/tesa_mitarbeiterfilm.mp4";